<template>
  <div class="space-y-4">
    <div class="grid gap-4 md:grid-cols-3">
      <InputField
        :readonly="handoverView"
        name="insuranceData.referenceNumber"
        :label="t('referenceNumber')"
      />
      <InputField
        v-if="!handoverView"
        name="insuranceData.initialDays"
        :label="t('initialDays')"
        type="number"
      />
      <SelectField
        :readonly="handoverView"
        name="insuranceData.volvoCategory"
        :options="volvoCategoryOptions"
        :label="t('volvoCategory')"
        empty-value-to="undefined"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import InputField from '@/components/InputField.vue';
import SelectField from '@/components/SelectField.vue';
import { VolvoVehicleCategory } from '@carvia/ros-client-types';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps<{
  handoverView?: boolean;
}>();

const { t } = useI18n();

const volvoCategoryOptions = computed(() => [
  { label: t('noCategory'), value: null },
  ...Object.values(VolvoVehicleCategory).map((category) => ({
    label: t(`volvoCategories.${category}`),
    value: category,
  })),
]);
</script>

<i18n lang="json">
{
  "en": {
    "referenceNumber": "Claim Number",
    "initialDays": "Covered days",
    "volvoCategory": "Volvo category",
    "noCategory": "- No category -"
  },
  "de": {
    "referenceNumber": "Claim-Nummer / Aktenzeichen",
    "initialDays": "Tagesanzahl laut KÜ",
    "volvoCategory": "Volvo Kategorie",
    "noCategory": "- Keine Kategorie -"
  },
  "es": {
    "referenceNumber": "N.º de siniestro / referencia",
    "initialDays": "Días cubiertos",
    "volvoCategory": "Categoría Volvo",
    "noCategory": "- Sin categoría -"
  }
}
</i18n>
